export class Events {
  static readonly PRINTER_HARD_RESET = 'printerHardReset';
  static readonly ENABLE_PRINTER = 'enablePrinter';
}
